export default "__VITE_ASSET__01705bdd__"